import { CustomerType } from "@origin-digital/platform-enums";
import { CommonParameters, IMcAppType, NavFlow, Tab } from "../mcApp.types";

const { accountNumber } = CommonParameters;

export const paymentPlanWizardSetup: IMcAppType = {
  name: "paymentPlanWizardSetup",
  path: "/my/payment-plan-wizard/debt-and-ongoing/checklist",
  parameters: {
    properties: { accountNumber },
  },
  description: "Wizard for setting up a customer payment plan",
  navFlow: NavFlow.FOCUS,
  title: "Payment Plan Wizard",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "paymentPlanWizardSetup",
    customerType: CustomerType.kraken,
  },
};
